// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AddonBin } from './addon-bin';
import { ItemDetailAddon } from './item-detail-addon';
import { AddonBinStationStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AddonBinStationStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: AddonBinStationStatusEnum;
  /** String(30) */
  name!: string;
  /** Inv FK currentAddonBinStationStatusId */
  addonBins!: AddonBin[];
  /** Inv FK addonBinStationStatusId */
  itemDetailAddons!: ItemDetailAddon[];
}

